import { useState } from 'react';
import { TabBar } from '@/components/ui/TabBar';
import VendorsPanel from './VendorsPanel';
import PurchaseOrdersPanel from './PurchaseOrdersPanel';
import GoodsReceiptPanel from './GoodsReceiptPanel';
import SupplierReturnsPanel from './SupplierReturnsPanel';

type ProcurementSubTab = 'grn' | 'po' | 'returns' | 'vendors';
const SUB_TABS: Array<{ id: ProcurementSubTab; label: string }> = [
  { id: 'grn', label: '📥 Goods Receipt' },
  { id: 'po', label: '📝 Purchase Orders' },
  { id: 'returns', label: '↩ Supplier returns' },
  { id: 'vendors', label: '🏢 Vendors' },
];

export default function ProcurementTab() {
  const [sub, setSub] = useState<ProcurementSubTab>('grn');

  return (
    <div>
      <TabBar tabs={SUB_TABS} active={sub} onChange={setSub} size="sm" className="mb-3.5" />
      {sub === 'vendors' && <VendorsPanel />}
      {sub === 'po' && <PurchaseOrdersPanel />}
      {sub === 'grn' && <GoodsReceiptPanel />}
      {sub === 'returns' && <SupplierReturnsPanel />}
    </div>
  );
}
